// HAFHToDoTranslations.js

const msmeOwnerPATranslations = {
  en: {
    pendingTasks: "Pending",
    taskCompletionRatio: "Completion Ratio",
    rcaEntries: "DeepThinking Entries",
    sakshamRanking: "SAKSHAM MSME Ranking",
    todoDate: "Date",
    todo1Title: "Follow-up with Vendor for Raw Material",
    todo1Desc: "Pending for 3 days | Priority: High",
    todo2Title: "GST Filing Preparation",
    todo2Desc: "Due in 2 days | Finance & Compliance",
    todo3Title: "Machine Breakdown RCA Update",
    todo3Desc: "Production Floor Observation",

    operations: "Operations",
    finance: "Finance",
    production: "Production",
    reminderEnabled: "Reminder Enabled",
    whatsappAlert: "WhatsApp Alert",
    rcaLinked: "RCA Linked",
    aiReminder: "AI Reminder",
    emailNotification: "Email Notification",
    correctiveActionPending: "Corrective Action Pending",

    list: "List",
    create: "Create",
    aiInsights: "AI Insights",
    reports: "Reports",
    myRank: "My Rank",
    rewards: "Rewards",

    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",

    taskCompletionPercent: "Task Completion %",
    dailyProductivityAI: "Daily Productivity AI for MSMEs Owners",
    heroDescription: "Daily Reflection, Routine, To-DO, Task Management, Diary Writing, Expense Tracking when in Hostel.",
    aiStack: "AI Stack",
    aiStackValue: "LLM + RAG + Cognitive + Agents",
    voiceAI: "Voice AI",
    todoList: "Daily Reflections",
    todoListDesc: "AI-assisted Chronicles Workflow",
    addTask: "Add New",
    ttsEnabled: "TTS Enabled",
    createTodo: "Create New",
    createTodoDesc:"Voice-enabled AI prompt support in creation workflow",
    taskTitle: "Title",
    enterTaskTitle: "Enter title",
    priority: "Priority",
    high: "High",
    medium: "Medium",
    low: "Low",
    taskDetails: "Details",
    taskDetailsPlaceholder:"Voice or text-based input in vernacular language",
    startVoiceInput: "Start Voice Input",
    refineWithAI: "Refine with AI",
    voiceSupportText:"Supports Speech-to-Text (STT) voice input for hands-free creation in vernacular languages.",
    productivityTrend: "Productivity Trend",
    weeklyAnalytics: "Weekly completion analytics",
    aiInsightsSignals: "AI Insights / AI Signals",
    aiInsightsDesc:"Contextual operational intelligence, cognitive AI, autonomous agents, operational diagnostics and MSME risk signals.",
    dailyChronicle: "Daily Chronicles",
    all: "All",
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    thisweek: "This Week",
    lastweek: "Last Week",
    nextweek: "Next Week",
    thismonth: "This Month",
    lastmonth: "Last Month",
    nextmonth: "Next Month",
    task: "Task",
    productivity: "Productivity",
    health: "Health",
    recreation: "Recreation",
    expenses: "Expenses",
    others: "Others",
    title: "Title:",
    section: "Section",
    evi: "Enable Voice Input",
    details: "Details",
    missingri: "Missing Required Information",

    plfillthefield: "Please fill the following field",
    status: "Status",
    deferred_date: "Deferred Date",
    who_suggested: "Who Suggested",
    etohadmin: "Escalate to Hostel Admin",

    applause: "Applause",
    applauseSub: "Give, receive, and track meaningful applause",
    gratitude: "Gratitude",
    applauseList: "Applause List",
    applauseListDesc: "Captured appreciation, feedback, and meaningful recognition in one place",
    addApplause: "Applause Again",
    listenList: "Listen List",
    myself: "Self Applause",
    tome: "I Got Applause",
    fromme: "I Applauded",
    createApplause: "Create Applause",
    createApplauseDesc: "Create Applause for Self, Other. Take Help of AI to write better and reply better!",
    applauseDate: "Applause Date",
    description: "Description",
    applauseTrend: "Applause Trend",
    monthlyAnalytics: "Monthly Anlytics",
    applausePercent: "Myself Applause %",

  },

  hi: {
    pendingTasks: "लंबित कार्य",
    taskCompletionRatio: "कार्य पूर्णता अनुपात",
    rcaEntries: "इस माह RCA प्रविष्टियाँ",
    sakshamRanking: "सक्षम MSME रैंकिंग",

    todo1Title: "कच्चे माल हेतु विक्रेता से फॉलो-अप",
    todo1Desc: "3 दिनों से लंबित | प्राथमिकता: उच्च",
    todo2Title: "GST फाइलिंग तैयारी",
    todo2Desc: "2 दिनों में देय | वित्त एवं अनुपालन",
    todo3Title: "मशीन ब्रेकडाउन RCA अपडेट",
    todo3Desc: "उत्पादन फ्लोर निरीक्षण",

    operations: "ऑपरेशन्स",
    finance: "वित्त",
    production: "उत्पादन",

    reminderEnabled: "रिमाइंडर सक्रिय",
    whatsappAlert: "व्हाट्सएप अलर्ट",
    rcaLinked: "RCA लिंक्ड",
    aiReminder: "AI रिमाइंडर",
    emailNotification: "ईमेल सूचना",
    correctiveActionPending: "सुधारात्मक कार्रवाई लंबित",

    list: "सूची",
    create: "बनाएँ",
    aiInsights: "AI अंतर्दृष्टि",
    reports: "रिपोर्ट",
    rewards: "पुरस्कार",

    mon: "सोम",
    tue: "मंगल",
    wed: "बुध",
    thu: "गुरु",
    fri: "शुक्र",
    sat: "शनि",

    taskCompletionPercent: "कार्य पूर्णता %",

    dailyProductivityAI: "MSME मालिकों हेतु दैनिक उत्पादकता AI",

    heroDescription:
      "AI-सहायित उत्पादकता, संचालन अनुशासन, रिमाइंडर, RCA ट्रैकिंग, AI संकेत, वॉइस वर्कफ़्लो और MSME परिवर्तन बुद्धिमत्ता।",

    aiStack: "AI स्टैक",
    aiStackValue: "LLM + RAG + कॉग्निटिव + एजेंट्स",

    voiceAI: "वॉइस AI",

    todoList: "कार्य सूची",
    todoListDesc: "AI-सहायित संचालन वर्कफ़्लो ट्रैकिंग",

    addTask: "कार्य जोड़ें",

    ttsEnabled: "TTS सक्रिय",

    createTodo: "नया कार्य बनाएँ",
    createTodoDesc:
      "वॉइस-सक्षम AI-सहायित कार्य निर्माण वर्कफ़्लो",

    taskTitle: "कार्य शीर्षक",
    enterTaskTitle: "कार्य शीर्षक दर्ज करें",

    priority: "प्राथमिकता",
    high: "उच्च",
    medium: "मध्यम",
    low: "निम्न",

    taskDetails: "कार्य विवरण",

    taskDetailsPlaceholder:
      "स्थानीय भाषा में वॉइस या टेक्स्ट आधारित कार्य इनपुट",

    startVoiceInput: "वॉइस इनपुट प्रारंभ करें",
    refineWithAI: "AI से परिष्कृत करें",

    voiceSupportText:
      "स्थानीय भाषाओं में हैंड्स-फ्री कार्य निर्माण हेतु Speech-to-Text (STT) समर्थन।",

    productivityTrend: "उत्पादकता प्रवृत्ति",
    weeklyAnalytics: "साप्ताहिक कार्य पूर्णता विश्लेषण",

    aiInsightsSignals: "AI अंतर्दृष्टि / AI संकेत",

    aiInsightsDesc:
      "संदर्भित संचालन बुद्धिमत्ता, कॉग्निटिव AI, स्वायत्त एजेंट्स, संचालन निदान एवं MSME जोखिम संकेत।",

    applause: "सराहना",
    applauseSub: "अर्थपूर्ण सराहना दें, प्राप्त करें और ट्रैक करें",
    gratitude: "आभार",
    applauseList: "सराहना सूची",
    applauseListDesc: "सराहना, प्रतिक्रिया और अर्थपूर्ण पहचान को एक ही स्थान पर संजोएँ",
    addApplause: "फिर से सराहना करें",
    listenList: "सूची सुनें",
    all: "सभी",
    myself: "स्वयं की सराहना",
    tome: "मुझे सराहना मिली",
    fromme: "मेरे द्वारा सराहना",
    createApplause: "सराहना बनाएँ",
    createApplauseDesc: "स्वयं या दूसरों के लिए सराहना बनाएँ। बेहतर लिखने और बेहतर उत्तर देने के लिए AI की सहायता लें!",
    applauseDate: "सराहना तिथि",
    description: "विवरण",
    applauseTrend: "सराहना प्रवृत्ति",
    monthlyAnalytics: "मासिक विश्लेषण",
    applausePercent: "स्वयं सराहना %",
    today: "आज",
    yesterday: "कल",
    tomorrow: "कल",
    thisweek: "इस सप्ताह",
    lastweek: "पिछले सप्ताह",
    nextweek: "अगले सप्ताह",
    thismonth: "इस महीने",
    lastmonth: "पिछले महीने",
    nextmonth: "अगले महीने",
  },

  mr: {
    pendingTasks: "प्रलंबित कामे",
    taskCompletionRatio: "काम पूर्णता प्रमाण",
    rcaEntries: "या महिन्यातील RCA नोंदी",
    sakshamRanking: "सक्षम MSME क्रमवारी",

    todo1Title: "कच्च्या मालासाठी विक्रेत्याशी फॉलो-अप",
    todo1Desc: "3 दिवसांपासून प्रलंबित | प्राधान्य: उच्च",
    todo2Title: "GST फाइलिंग तयारी",
    todo2Desc: "2 दिवसांत देय | वित्त आणि अनुपालन",
    todo3Title: "मशीन ब्रेकडाउन RCA अद्यतन",
    todo3Desc: "उत्पादन विभाग निरीक्षण",

    operations: "ऑपरेशन्स",
    finance: "वित्त",
    production: "उत्पादन",

    reminderEnabled: "स्मरणपत्र सक्रिय",
    whatsappAlert: "व्हॉट्सअॅप अलर्ट",
    rcaLinked: "RCA लिंक",
    aiReminder: "AI स्मरणपत्र",
    emailNotification: "ईमेल सूचना",
    correctiveActionPending: "सुधारात्मक कृती प्रलंबित",

    list: "यादी",
    create: "तयार करा",
    aiInsights: "AI अंतर्दृष्टी",
    reports: "अहवाल",
    rewards: "पुरस्कार",

    mon: "सोम",
    tue: "मंगळ",
    wed: "बुध",
    thu: "गुरु",
    fri: "शुक्र",
    sat: "शनि",

    taskCompletionPercent: "काम पूर्णता %",

    dailyProductivityAI: "MSME मालकांसाठी दैनिक उत्पादकता AI",

    heroDescription:
      "AI-सहाय्यित उत्पादकता, कार्यशिस्त, स्मरणपत्रे, RCA ट्रॅकिंग, AI संकेत, व्हॉइस वर्कफ्लो आणि MSME परिवर्तन बुद्धिमत्ता.",

    aiStack: "AI स्टॅक",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "व्हॉइस AI",

    todoList: "कार्य यादी",
    todoListDesc: "AI-सहाय्यित ऑपरेशनल वर्कफ्लो ट्रॅकिंग",

    addTask: "कार्य जोडा",

    ttsEnabled: "TTS सक्रिय",

    createTodo: "नवीन कार्य तयार करा",
    createTodoDesc:
      "व्हॉइस-सक्षम AI-सहाय्यित कार्य निर्मिती प्रक्रिया",

    taskTitle: "कार्य शीर्षक",
    enterTaskTitle: "कार्य शीर्षक प्रविष्ट करा",

    priority: "प्राधान्य",
    high: "उच्च",
    medium: "मध्यम",
    low: "कमी",

    taskDetails: "कार्य तपशील",

    taskDetailsPlaceholder:
      "स्थानिक भाषेत व्हॉइस किंवा मजकूर आधारित कार्य इनपुट",

    startVoiceInput: "व्हॉइस इनपुट सुरू करा",
    refineWithAI: "AI सह सुधारणा करा",

    voiceSupportText:
      "स्थानिक भाषांमध्ये हँड्स-फ्री कार्य निर्मितीसाठी Speech-to-Text (STT) समर्थन.",

    productivityTrend: "उत्पादकता ट्रेंड",
    weeklyAnalytics: "साप्ताहिक कार्य पूर्णता विश्लेषण",

    aiInsightsSignals: "AI अंतर्दृष्टी / AI संकेत",

    aiInsightsDesc:
      "संदर्भाधारित ऑपरेशनल बुद्धिमत्ता, Cognitive AI, स्वयंचलित एजंट्स आणि MSME जोखीम संकेत.",

    applause: "कौतुक",
    applauseSub: "अर्थपूर्ण कौतुक द्या, स्वीकारा आणि ट्रॅक करा",
    gratitude: "कृतज्ञता",
    applauseList: "कौतुक यादी",
    applauseListDesc: "कौतुक, अभिप्राय आणि अर्थपूर्ण ओळख एका ठिकाणी जतन करा",
    addApplause: "पुन्हा कौतुक करा",
    listenList: "यादी ऐका",
    all: "सर्व",
    myself: "स्वतःचे कौतुक",
    tome: "मला कौतुक मिळाले",
    fromme: "माझ्याकडून कौतुक",
    createApplause: "कौतुक तयार करा",
    createApplauseDesc: "स्वतःसाठी किंवा इतरांसाठी कौतुक तयार करा. अधिक चांगले लिहिण्यासाठी आणि उत्तम उत्तर देण्यासाठी AI ची मदत घ्या!",
    applauseDate: "कौतुक दिनांक",
    description: "वर्णन",
    applauseTrend: "कौतुक प्रवाह",
    monthlyAnalytics: "मासिक विश्लेषण",
    applausePercent: "स्वतःच्या कौतुकाचे %",
    today: "आज",
    yesterday: "काल",
    tomorrow: "उद्या",
    thisweek: "या आठवड्यात",
    lastweek: "मागील आठवड्यात",
    nextweek: "पुढील आठवड्यात",
    thismonth: "या महिन्यात",
    lastmonth: "मागील महिन्यात",
    nextmonth: "पुढील महिन्यात",
  },

  gu: { 
    pendingTasks: "બાકી કાર્યો",
    taskCompletionRatio: "કાર્ય પૂર્ણતા પ્રમાણ",
    rcaEntries: "આ મહિનાની RCA એન્ટ્રીઓ",
    sakshamRanking: "સક્ષમ MSME રેન્કિંગ",

    todo1Title: "કાચા માલ માટે વેન્ડર સાથે અનુસરણ",
    todo1Desc: "3 દિવસથી બાકી | પ્રાથમિકતા: ઊંચી",
    todo2Title: "GST ફાઇલિંગ તૈયારી",
    todo2Desc: "2 દિવસમાં બાકી | નાણાં અને પાલન",
    todo3Title: "મશીન બ્રેકડાઉન RCA અપડેટ",
    todo3Desc: "ઉત્પાદન ફ્લોર નિરીક્ષણ",

    operations: "ઓપરેશન્સ",
    finance: "નાણાં",
    production: "ઉત્પાદન",

    reminderEnabled: "રીમાઇન્ડર સક્રિય",
    whatsappAlert: "વોટ્સએપ એલર્ટ",
    rcaLinked: "RCA જોડાયેલ",
    aiReminder: "AI રીમાઇન્ડર",
    emailNotification: "ઈમેલ સૂચના",
    correctiveActionPending: "સુધારાત્મક કાર્યવાહી બાકી",

    list: "યાદી",
    create: "બનાવો",
    aiInsights: "AI સમજણ",
    reports: "રિપોર્ટ્સ",
    rewards: "ઇનામો",

    mon: "સોમ",
    tue: "મંગળ",
    wed: "બુધ",
    thu: "ગુરુ",
    fri: "શુક્ર",
    sat: "શનિ",

    taskCompletionPercent: "કાર્ય પૂર્ણતા %",

    dailyProductivityAI: "MSME માલિકો માટે દૈનિક પ્રોડક્ટિવિટી AI",

    heroDescription:
        "AI આધારિત પ્રોડક્ટિવિટી, ઓપરેશનલ શિસ્ત, રીમાઇન્ડર્સ, RCA ટ્રેકિંગ, AI સિગ્નલ્સ, વોઇસ વર્કફ્લો અને MSME ટ્રાન્સફોર્મેશન ઈન્ટેલિજન્સ.",

    aiStack: "AI સ્ટેક",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "વોઇસ AI",

    todoList: "કાર્ય સૂચિ",
    todoListDesc: "AI આધારિત ઓપરેશનલ વર્કફ્લો ટ્રેકિંગ",

    addTask: "કાર્ય ઉમેરો",

    ttsEnabled: "TTS સક્રિય",

    createTodo: "નવું કાર્ય બનાવો",
    createTodoDesc:
        "વોઇસ સક્ષમ AI આધારિત કાર્ય સર્જન વર્કફ્લો",

    taskTitle: "કાર્ય શીર્ષક",
    enterTaskTitle: "કાર્ય શીર્ષક દાખલ કરો",

    priority: "પ્રાથમિકતા",
    high: "ઉચ્ચ",
    medium: "મધ્યમ",
    low: "નીચું",

    taskDetails: "કાર્ય વિગતો",

    taskDetailsPlaceholder:
        "સ્થાનિક ભાષામાં વોઇસ અથવા ટેક્સ્ટ આધારિત કાર્ય ઇનપુટ",

    startVoiceInput: "વોઇસ ઇનપુટ શરૂ કરો",
    refineWithAI: "AI સાથે સુધારો",

    voiceSupportText:
        "સ્થાનિક ભાષાઓમાં હેન્ડ્સ-ફ્રી કાર્ય સર્જન માટે Speech-to-Text (STT) આધાર.",

    productivityTrend: "ઉત્પાદકતા પ્રવાહ",
    weeklyAnalytics: "સાપ્તાહિક કાર્ય પૂર્ણતા વિશ્લેષણ",

    aiInsightsSignals: "AI ઇન્સાઇટ્સ / AI સિગ્નલ્સ",

    aiInsightsDesc:"સંદર્ભ આધારિત ઓપરેશનલ ઇન્ટેલિજન્સ, Cognitive AI, સ્વાયત્ત એજન્ટ્સ, ઓપરેશનલ ડાયગ્નોસ્ટિક્સ અને MSME જોખમ સિગ્નલ્સ.",
    
    applause: "તાળીઓ",
    applauseSub: "અર્થપૂર્ણ પ્રશંસા આપો, મેળવો અને ટ્રેક કરો",
    gratitude: "કૃતજ્ઞતા",
    applauseList: "તાળીઓની સૂચિ",
    applauseListDesc: "પ્રશંસા, પ્રતિસાદ અને અર્થપૂર્ણ માન્યતા એક જ જગ્યાએ સંગ્રહિત",
    addApplause: "ફરી તાળીઓ આપો",
    listenList: "સાંભળવાની સૂચિ",
    all: "બધા",
    myself: "સ્વ-પ્રશંસા",
    tome: "મને તાળીઓ મળી",
    fromme: "મેં તાળીઓ આપી",
    createApplause: "તાળીઓ બનાવો",
    createApplauseDesc: "પોતાને અથવા અન્ય માટે તાળીઓ બનાવો. વધુ સારું લખવા અને જવાબ આપવા માટે AI ની મદદ લો!",
    applauseDate: "તાળીઓની તારીખ",
    description: "વર્ણન",
    applauseTrend: "તાળીઓનો ટ્રેન્ડ",
    monthlyAnalytics: "માસિક વિશ્લેષણ",
    applausePercent: "મારી સ્વ-પ્રશંસા %",      
    today: "આજે",
    yesterday: "ગઈકાલે",
    tomorrow: "આવતીકાલે",
    thisweek: "આ અઠવાડિયે",
    lastweek: "ગયા અઠવાડિયે",
    nextweek: "આવતા અઠવાડિયે",
    thismonth: "આ મહિને",
    lastmonth: "ગયા મહિને",
    nextmonth: "આવતા મહિને", 
  },

  bn: {
    pendingTasks: "মুলতুবি কাজ",
    taskCompletionRatio: "কাজ সম্পন্ন অনুপাত",
    rcaEntries: "এই মাসের RCA এন্ট্রি",
    sakshamRanking: "সক্ষম MSME র‌্যাঙ্কিং",

    todo1Title: "কাঁচামালের জন্য বিক্রেতার সাথে ফলো-আপ",
    todo1Desc: "৩ দিন ধরে মুলতুবি | অগ্রাধিকার: উচ্চ",
    todo2Title: "GST ফাইলিং প্রস্তুতি",
    todo2Desc: "২ দিনের মধ্যে জমা | ফাইন্যান্স ও কমপ্লায়েন্স",
    todo3Title: "মেশিন ব্রেকডাউন RCA আপডেট",
    todo3Desc: "প্রোডাকশন ফ্লোর পর্যবেক্ষণ",

    operations: "অপারেশনস",
    finance: "ফাইন্যান্স",
    production: "উৎপাদন",

    reminderEnabled: "রিমাইন্ডার সক্রিয়",
    whatsappAlert: "হোয়াটসঅ্যাপ অ্যালার্ট",
    rcaLinked: "RCA সংযুক্ত",
    aiReminder: "AI রিমাইন্ডার",
    emailNotification: "ইমেইল নোটিফিকেশন",
    correctiveActionPending: "সংশোধনী ব্যবস্থা মুলতুবি",

    list: "তালিকা",
    create: "তৈরি করুন",
    aiInsights: "AI অন্তর্দৃষ্টি",
    reports: "রিপোর্ট",
    rewards: "পুরস্কার",

    mon: "সোম",
    tue: "মঙ্গল",
    wed: "বুধ",
    thu: "বৃহস্পতি",
    fri: "শুক্র",
    sat: "শনি",

    taskCompletionPercent: "কাজ সম্পন্ন %",

    dailyProductivityAI: "MSME মালিকদের জন্য দৈনিক প্রোডাক্টিভিটি AI",

    heroDescription:
        "AI-সহায়ক প্রোডাক্টিভিটি, অপারেশনাল শৃঙ্খলা, রিমাইন্ডার, RCA ট্র্যাকিং, AI সিগন্যাল, ভয়েস ওয়ার্কফ্লো এবং MSME ট্রান্সফরমেশন ইন্টেলিজেন্স।",

    aiStack: "AI স্ট্যাক",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ভয়েস AI",

    todoList: "কাজের তালিকা",
    todoListDesc: "AI-সহায়ক অপারেশনাল ওয়ার্কফ্লো ট্র্যাকিং",

    addTask: "কাজ যোগ করুন",

    ttsEnabled: "TTS সক্রিয়",

    createTodo: "নতুন কাজ তৈরি করুন",
    createTodoDesc:
        "ভয়েস-সক্ষম AI-সহায়ক কাজ তৈরির ওয়ার্কফ্লো",

    taskTitle: "কাজের শিরোনাম",
    enterTaskTitle: "কাজের শিরোনাম লিখুন",

    priority: "অগ্রাধিকার",
    high: "উচ্চ",
    medium: "মাঝারি",
    low: "নিম্ন",

    taskDetails: "কাজের বিবরণ",

    taskDetailsPlaceholder:
        "স্থানীয় ভাষায় ভয়েস বা টেক্সট ভিত্তিক কাজ ইনপুট",

    startVoiceInput: "ভয়েস ইনপুট শুরু করুন",
    refineWithAI: "AI দিয়ে উন্নত করুন",

    voiceSupportText:
        "স্থানীয় ভাষায় হ্যান্ডস-ফ্রি কাজ তৈরির জন্য Speech-to-Text (STT) সমর্থন।",

    productivityTrend: "উৎপাদনশীলতার প্রবণতা",
    weeklyAnalytics: "সাপ্তাহিক কাজ সম্পন্ন বিশ্লেষণ",

    aiInsightsSignals: "AI ইনসাইটস / AI সিগন্যাল",

    aiInsightsDesc:
        "প্রাসঙ্গিক অপারেশনাল ইন্টেলিজেন্স, Cognitive AI, স্বয়ংক্রিয় এজেন্ট, অপারেশনাল ডায়াগনস্টিকস এবং MSME ঝুঁকি সিগন্যাল।",

    applause: "প্রশংসা",
    applauseSub: "অর্থপূর্ণ প্রশংসা দিন, গ্রহণ করুন এবং ট্র্যাক করুন",
    gratitude: "কৃতজ্ঞতা",
    applauseList: "প্রশংসার তালিকা",
    applauseListDesc: "প্রশংসা, প্রতিক্রিয়া এবং অর্থপূর্ণ স্বীকৃতি এক জায়গায় সংরক্ষিত",
    addApplause: "আবার প্রশংসা করুন",
    listenList: "শুনুন তালিকা",
    myself: "নিজেকে প্রশংসা",
    tome: "আমি প্রশংসা পেয়েছি",
    fromme: "আমি প্রশংসা করেছি",
    createApplause: "প্রশংসা তৈরি করুন",
    createApplauseDesc: "নিজের বা অন্যের জন্য প্রশংসা তৈরি করুন। আরও ভালোভাবে লিখতে এবং উত্তর দিতে AI-এর সাহায্য নিন!",
    applauseDate: "প্রশংসার তারিখ",
    description: "বিবরণ",
    applauseTrend: "প্রশংসার প্রবণতা",
    monthlyAnalytics: "মাসিক বিশ্লেষণ",
    applausePercent: "নিজস্ব প্রশংসার %",
    all: "সব",
    today: "আজ",
    yesterday: "গতকাল",
    tomorrow: "আগামীকাল",
    thisweek: "এই সপ্তাহ",
    lastweek: "গত সপ্তাহ",
    nextweek: "আগামী সপ্তাহ",
    thismonth: "এই মাস",
    lastmonth: "গত মাস",
    nextmonth: "আগামী মাস",   
  },

  ta: {
    pendingTasks: "நிலுவையில் உள்ள பணிகள்",
    taskCompletionRatio: "பணி நிறைவு விகிதம்",
    rcaEntries: "இந்த மாத RCA பதிவுகள்",
    sakshamRanking: "சக்ஷம் MSME தரவரிசை",

    todo1Title: "மூலப்பொருள் விற்பனையாளரை தொடர்புகொள்",
    todo1Desc: "3 நாட்களாக நிலுவையில் | முன்னுரிமை: உயர்ந்தது",
    todo2Title: "GST தாக்கல் தயாரிப்பு",
    todo2Desc: "2 நாட்களில் கடைசி தேதி | நிதி & இணக்கம்",
    todo3Title: "இயந்திர கோளாறு RCA புதுப்பிப்பு",
    todo3Desc: "உற்பத்தி தளம் கண்காணிப்பு",

    operations: "செயல்பாடுகள்",
    finance: "நிதி",
    production: "உற்பத்தி",

    reminderEnabled: "நினைவூட்டல் செயல்படுத்தப்பட்டது",
    whatsappAlert: "வாட்ஸ்அப் எச்சரிக்கை",
    rcaLinked: "RCA இணைக்கப்பட்டது",
    aiReminder: "AI நினைவூட்டல்",
    emailNotification: "மின்னஞ்சல் அறிவிப்பு",
    correctiveActionPending: "திருத்த நடவடிக்கை நிலுவையில்",

    list: "பட்டியல்",
    create: "உருவாக்கு",
    aiInsights: "AI பார்வைகள்",
    reports: "அறிக்கைகள்",
    rewards: "வெகுமதிகள்",

    mon: "திங்",
    tue: "செவ்",
    wed: "புத",
    thu: "வியா",
    fri: "வெள்",
    sat: "சனி",

    taskCompletionPercent: "பணி நிறைவு %",

    dailyProductivityAI: "MSME உரிமையாளர்களுக்கான தினசரி உற்பத்தித்திறன் AI",

    heroDescription:
        "AI உதவியுள்ள உற்பத்தித்திறன், செயல்பாட்டு ஒழுங்கு, நினைவூட்டல்கள், RCA கண்காணிப்பு, AI சிக்னல்கள், குரல் செயல்முறை மற்றும் MSME மாற்ற நுண்ணறிவு.",

    aiStack: "AI ஸ்டாக்",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "குரல் AI",

    todoList: "செய்ய வேண்டிய பட்டியல்",
    todoListDesc: "AI உதவியுள்ள செயல்பாட்டு பணிச்சூழல் கண்காணிப்பு",

    addTask: "பணியைச் சேர்க்கவும்",

    ttsEnabled: "TTS செயல்படுத்தப்பட்டது",

    createTodo: "புதிய பணியை உருவாக்கு",
    createTodoDesc:
        "குரல் ஆதரவு கொண்ட AI உதவியுள்ள பணி உருவாக்கம்",

    taskTitle: "பணி தலைப்பு",
    enterTaskTitle: "பணி தலைப்பை உள்ளிடவும்",

    priority: "முன்னுரிமை",
    high: "உயர்",
    medium: "நடுத்தரம்",
    low: "குறைவு",

    taskDetails: "பணி விவரங்கள்",

    taskDetailsPlaceholder:
        "உள்ளூர் மொழியில் குரல் அல்லது உரை அடிப்படையிலான பணி உள்ளீடு",

    startVoiceInput: "குரல் உள்ளீட்டை தொடங்கு",
    refineWithAI: "AI மூலம் மேம்படுத்து",

    voiceSupportText:
        "உள்ளூர் மொழிகளில் ஹேண்ட்ஸ்-ஃப்ரீ பணி உருவாக்கத்திற்கான Speech-to-Text (STT) ஆதரவு।",

    productivityTrend: "உற்பத்தித்திறன் போக்கு",
    weeklyAnalytics: "வாராந்திர பணி நிறைவு பகுப்பாய்வு",

    aiInsightsSignals: "AI பார்வைகள் / AI சிக்னல்கள்",

    aiInsightsDesc:
        "சூழல் சார்ந்த செயல்பாட்டு நுண்ணறிவு, Cognitive AI, தன்னாட்சி முகவர்கள், செயல்பாட்டு கண்டறிதல் மற்றும் MSME அபாய சிக்னல்கள்।",

    applause: "பாராட்டு",
    applauseSub: "அர்த்தமுள்ள பாராட்டுகளை வழங்கவும், பெறவும் மற்றும் கண்காணிக்கவும்",
    gratitude: "நன்றியுணர்வு",
    applauseList: "பாராட்டு பட்டியல்",
    applauseListDesc: "பாராட்டு, கருத்து மற்றும் அர்த்தமுள்ள அங்கீகாரம் ஒரே இடத்தில் சேமிக்கப்பட்டது",
    addApplause: "மீண்டும் பாராட்டு வழங்கவும்",
    listenList: "கேட்கும் பட்டியல்",
    myself: "சுய பாராட்டு",
    tome: "எனக்கு பாராட்டு கிடைத்தது",
    fromme: "நான் பாராட்டினேன்",
    createApplause: "பாராட்டு உருவாக்கவும்",
    createApplauseDesc: "தனக்கோ அல்லது பிறருக்கோ பாராட்டு உருவாக்குங்கள். சிறப்பாக எழுதவும் பதிலளிக்கவும் AI உதவியை பயன்படுத்துங்கள்!",
    applauseDate: "பாராட்டு தேதி",
    description: "விளக்கம்",
    applauseTrend: "பாராட்டு போக்கு",
    monthlyAnalytics: "மாதாந்திர பகுப்பாய்வு",
    applausePercent: "என் சுய பாராட்டு %",
    all: "அனைத்தும்",
    today: "இன்று",
    yesterday: "நேற்று",
    tomorrow: "நாளை",
    thisweek: "இந்த வாரம்",
    lastweek: "கடந்த வாரம்",
    nextweek: "அடுத்த வாரம்",
    thismonth: "இந்த மாதம்",
    lastmonth: "கடந்த மாதம்",
    nextmonth: "அடுத்த மாதம்",
  },

  te: {
    pendingTasks: "పెండింగ్ పనులు",
    taskCompletionRatio: "పని పూర్తి నిష్పత్తి",
    rcaEntries: "ఈ నెల RCA నమోదు",
    sakshamRanking: "సక్షమ్ MSME ర్యాంకింగ్",

    todo1Title: "ముడి సరుకు కోసం విక్రేతను ఫాలోఅప్ చేయండి",
    todo1Desc: "3 రోజులుగా పెండింగ్ | ప్రాధాన్యత: అధికం",
    todo2Title: "GST ఫైలింగ్ సిద్ధత",
    todo2Desc: "2 రోజుల్లో గడువు | ఫైనాన్స్ & కంప్లయన్స్",
    todo3Title: "మెషిన్ బ్రేక్‌డౌన్ RCA అప్డేట్",
    todo3Desc: "ఉత్పత్తి విభాగ పరిశీలన",

    operations: "ఆపరేషన్స్",
    finance: "ఫైనాన్స్",
    production: "ఉత్పత్తి",

    reminderEnabled: "రిమైండర్ ప్రారంభించబడింది",
    whatsappAlert: "వాట్సాప్ అలర్ట్",
    rcaLinked: "RCA లింక్ చేయబడింది",
    aiReminder: "AI రిమైండర్",
    emailNotification: "ఇమెయిల్ నోటిఫికేషన్",
    correctiveActionPending: "సరిదిద్దే చర్య పెండింగ్‌లో ఉంది",

    list: "జాబితా",
    create: "సృష్టించు",
    aiInsights: "AI అవగాహనలు",
    reports: "నివేదికలు",
    rewards: "బహుమతులు",

    mon: "సోమ",
    tue: "మంగళ",
    wed: "బుధ",
    thu: "గురు",
    fri: "శుక్ర",
    sat: "శని",

    taskCompletionPercent: "పని పూర్తి %",

    dailyProductivityAI: "MSME యజమానుల కోసం రోజువారీ ఉత్పాదకత AI",

    heroDescription:
        "AI ఆధారిత ఉత్పాదకత, ఆపరేషనల్ క్రమశిక్షణ, రిమైండర్లు, RCA ట్రాకింగ్, AI సంకేతాలు, వాయిస్ వర్క్‌ఫ్లోలు మరియు MSME మార్పు ఇంటెలిజెన్స్।",

    aiStack: "AI స్టాక్",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "వాయిస్ AI",

    todoList: "చేయవలసిన పనుల జాబితా",
    todoListDesc: "AI ఆధారిత ఆపరేషనల్ వర్క్‌ఫ్లో ట్రాకింగ్",

    addTask: "పని జోడించండి",

    ttsEnabled: "TTS ప్రారంభించబడింది",

    createTodo: "కొత్త పని సృష్టించండి",
    createTodoDesc:
        "వాయిస్ ఆధారిత AI సహాయక పని సృష్టి వర్క్‌ఫ్లో",

    taskTitle: "పని శీర్షిక",
    enterTaskTitle: "పని శీర్షికను నమోదు చేయండి",

    priority: "ప్రాధాన్యత",
    high: "అధికం",
    medium: "మధ్యస్థం",
    low: "తక్కువ",

    taskDetails: "పని వివరాలు",

    taskDetailsPlaceholder:
        "స్థానిక భాషలో వాయిస్ లేదా టెక్స్ట్ ఆధారిత పని ఇన్‌పుట్",

    startVoiceInput: "వాయిస్ ఇన్‌పుట్ ప్రారంభించండి",
    refineWithAI: "AI తో మెరుగుపరచండి",

    voiceSupportText:
        "స్థానిక భాషలలో హ్యాండ్స్-ఫ్రీ పని సృష్టి కోసం Speech-to-Text (STT) మద్దతు।",

    productivityTrend: "ఉత్పాదకత ధోరణి",
    weeklyAnalytics: "వారపు పని పూర్తి విశ్లేషణ",

    aiInsightsSignals: "AI ఇన్‌సైట్స్ / AI సంకేతాలు",

    aiInsightsDesc:
        "సందర్భాత్మక ఆపరేషనల్ ఇంటెలిజెన్స్, Cognitive AI, స్వయంచాలక ఏజెంట్లు, ఆపరేషనల్ డయాగ్నోస్టిక్స్ మరియు MSME రిస్క్ సంకేతాలు।",

    applause: "ప్రశంస",
    applauseSub: "అర్థవంతమైన ప్రశంసలను ఇవ్వండి, పొందండి మరియు ట్రాక్ చేయండి",
    gratitude: "కృతజ్ఞత",
    applauseList: "ప్రశంసల జాబితా",
    applauseListDesc: "ప్రశంసలు, అభిప్రాయాలు మరియు అర్థవంతమైన గుర్తింపును ఒకే చోట భద్రపరచండి",
    addApplause: "మళ్లీ ప్రశంసించండి",
    listenList: "వినికిడి జాబితా",
    myself: "స్వీయ ప్రశంస",
    tome: "నాకు ప్రశంస లభించింది",
    fromme: "నేను ప్రశంసించాను",
    createApplause: "ప్రశంస సృష్టించండి",
    createApplauseDesc: "మీ కోసం లేదా ఇతరుల కోసం ప్రశంస సృష్టించండి. మెరుగ్గా రాయడానికి మరియు సమాధానం ఇవ్వడానికి AI సహాయం పొందండి!",
    applauseDate: "ప్రశంస తేదీ",
    description: "వివరణ",
    applauseTrend: "ప్రశంస ధోరణి",
    monthlyAnalytics: "నెలవారీ విశ్లేషణ",
    applausePercent: "నా స్వీయ ప్రశంస %",
    all: "అన్నీ",
    today: "ఈ రోజు",
    yesterday: "నిన్న",
    tomorrow: "రేపు",
    thisweek: "ఈ వారం",
    lastweek: "గత వారం",
    nextweek: "తదుపరి వారం",
    thismonth: "ఈ నెల",
    lastmonth: "గత నెల",
    nextmonth: "తదుపరి నెల",     
  },

  kn: {
    pendingTasks: "ಬಾಕಿ ಕೆಲಸಗಳು",
    taskCompletionRatio: "ಕಾರ್ಯ ಪೂರ್ಣತಾ ಪ್ರಮಾಣ",
    rcaEntries: "ಈ ತಿಂಗಳ RCA ನಮೂದುಗಳು",
    sakshamRanking: "ಸಕ್ಷಮ್ MSME ಶ್ರೇಯಾಂಕ",

    todo1Title: "ಮೂಲ ವಸ್ತುಗಳಿಗಾಗಿ ಮಾರಾಟಗಾರರನ್ನು ಅನುಸರಿಸಿ",
    todo1Desc: "3 ದಿನಗಳಿಂದ ಬಾಕಿ | ಆದ್ಯತೆ: ಹೆಚ್ಚು",
    todo2Title: "GST ಫೈಲಿಂಗ್ ತಯಾರಿ",
    todo2Desc: "2 ದಿನಗಳಲ್ಲಿ ಕೊನೆಯ ದಿನಾಂಕ | ಹಣಕಾಸು ಮತ್ತು ಅನುಸರಣೆ",
    todo3Title: "ಯಂತ್ರ ದೋಷ RCA ನವೀಕರಣ",
    todo3Desc: "ಉತ್ಪಾದನಾ ಘಟಕ ವೀಕ್ಷಣೆ",

    operations: "ಆಪರೇಷನ್ಸ್",
    finance: "ಹಣಕಾಸು",
    production: "ಉತ್ಪಾದನೆ",

    reminderEnabled: "ಜ್ಞಾಪನೆ ಸಕ್ರಿಯಗೊಂಡಿದೆ",
    whatsappAlert: "ವಾಟ್ಸಾಪ್ ಅಲರ್ಟ್",
    rcaLinked: "RCA ಲಿಂಕ್ ಮಾಡಲಾಗಿದೆ",
    aiReminder: "AI ಜ್ಞಾಪನೆ",
    emailNotification: "ಇಮೇಲ್ ಅಧಿಸೂಚನೆ",
    correctiveActionPending: "ತಿದ್ದುಪಡಿ ಕ್ರಮ ಬಾಕಿಯಿದೆ",

    list: "ಪಟ್ಟಿ",
    create: "ರಚಿಸಿ",
    aiInsights: "AI ಒಳನೋಟಗಳು",
    reports: "ವರದಿಗಳು",
    rewards: "ಬಹುಮಾನಗಳು",

    mon: "ಸೋಮ",
    tue: "ಮಂಗಳ",
    wed: "ಬುಧ",
    thu: "ಗುರು",
    fri: "ಶುಕ್ರ",
    sat: "ಶನಿ",

    taskCompletionPercent: "ಕಾರ್ಯ ಪೂರ್ಣತೆ %",

    dailyProductivityAI: "MSME ಮಾಲೀಕರಿಗಾಗಿ ದೈನಂದಿನ ಉತ್ಪಾದಕತೆ AI",

    heroDescription:
        "AI ಸಹಾಯಕ ಉತ್ಪಾದಕತೆ, ಕಾರ್ಯಾಚರಣಾ ಶಿಸ್ತು, ಜ್ಞಾಪನೆಗಳು, RCA ಟ್ರ್ಯಾಕಿಂಗ್, AI ಸಂಕೇತಗಳು, ಧ್ವನಿ ಕಾರ್ಯಪ್ರವಾಹಗಳು ಮತ್ತು MSME ಪರಿವರ್ತನಾ ಬುದ್ಧಿಮತ್ತೆ।",

    aiStack: "AI ಸ್ಟ್ಯಾಕ್",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ವಾಯ್ಸ್ AI",

    todoList: "ಮಾಡಬೇಕಾದ ಕಾರ್ಯಗಳ ಪಟ್ಟಿ",
    todoListDesc: "AI ಸಹಾಯಕ ಕಾರ್ಯಾಚರಣಾ ಕಾರ್ಯಪ್ರವಾಹ ಟ್ರ್ಯಾಕಿಂಗ್",

    addTask: "ಕಾರ್ಯ ಸೇರಿಸಿ",

    ttsEnabled: "TTS ಸಕ್ರಿಯಗೊಂಡಿದೆ",

    createTodo: "ಹೊಸ ಕಾರ್ಯ ರಚಿಸಿ",
    createTodoDesc:
        "ಧ್ವನಿ ಆಧಾರಿತ AI ಸಹಾಯಕ ಕಾರ್ಯ ರಚನೆ ಕಾರ್ಯಪ್ರವಾಹ",

    taskTitle: "ಕಾರ್ಯ ಶೀರ್ಷಿಕೆ",
    enterTaskTitle: "ಕಾರ್ಯ ಶೀರ್ಷಿಕೆಯನ್ನು ನಮೂದಿಸಿ",

    priority: "ಆದ್ಯತೆ",
    high: "ಹೆಚ್ಚು",
    medium: "ಮಧ್ಯಮ",
    low: "ಕಡಿಮೆ",

    taskDetails: "ಕಾರ್ಯ ವಿವರಗಳು",

    taskDetailsPlaceholder:
        "ಸ್ಥಳೀಯ ಭಾಷೆಯಲ್ಲಿ ಧ್ವನಿ ಅಥವಾ ಪಠ್ಯ ಆಧಾರಿತ ಕಾರ್ಯ ಇನ್‌ಪುಟ್",

    startVoiceInput: "ಧ್ವನಿ ಇನ್‌ಪುಟ್ ಪ್ರಾರಂಭಿಸಿ",
    refineWithAI: "AI ಮೂಲಕ ಸುಧಾರಿಸಿ",

    voiceSupportText:
        "ಸ್ಥಳೀಯ ಭಾಷೆಗಳಲ್ಲಿ ಹ್ಯಾಂಡ್ಸ್-ಫ್ರೀ ಕಾರ್ಯ ರಚನೆಗಾಗಿ Speech-to-Text (STT) ಬೆಂಬಲ।",

    productivityTrend: "ಉತ್ಪಾದಕತೆ ಪ್ರವೃತ್ತಿ",
    weeklyAnalytics: "ವಾರದ ಕಾರ್ಯ ಪೂರ್ಣತೆ ವಿಶ್ಲೇಷಣೆ",

    aiInsightsSignals: "AI ಒಳನೋಟಗಳು / AI ಸಂಕೇತಗಳು",

    aiInsightsDesc:
        "ಸಂದರ್ಭಾತ್ಮಕ ಕಾರ್ಯಾಚರಣಾ ಬುದ್ಧಿಮತ್ತೆ, Cognitive AI, ಸ್ವಯಂಚಾಲಿತ ಏಜೆಂಟ್‌ಗಳು, ಕಾರ್ಯಾಚರಣಾ ಡಯಾಗ್ನೋಸ್ಟಿಕ್ಸ್ ಮತ್ತು MSME ಅಪಾಯ ಸಂಕೇತಗಳು।",

    applause: "ಪ್ರಶಂಸೆ",
    applauseSub: "ಅರ್ಥಪೂರ್ಣ ಪ್ರಶಂಸೆಗಳನ್ನು ನೀಡಿ, ಸ್ವೀಕರಿಸಿ ಮತ್ತು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ",
    gratitude: "ಕೃತಜ್ಞತೆ",
    applauseList: "ಪ್ರಶಂಸೆ ಪಟ್ಟಿ",
    applauseListDesc: "ಪ್ರಶಂಸೆ, ಪ್ರತಿಕ್ರಿಯೆ ಮತ್ತು ಅರ್ಥಪೂರ್ಣ ಮಾನ್ಯತೆಯನ್ನು ಒಂದೇ ಸ್ಥಳದಲ್ಲಿ ಸಂಗ್ರಹಿಸಲಾಗಿದೆ",
    addApplause: "ಮತ್ತೊಮ್ಮೆ ಪ್ರಶಂಸಿಸಿ",
    listenList: "ಆಲಿಸುವ ಪಟ್ಟಿ",
    myself: "ಸ್ವಯಂ ಪ್ರಶಂಸೆ",
    tome: "ನನಗೆ ಪ್ರಶಂಸೆ ದೊರಕಿತು",
    fromme: "ನಾನು ಪ್ರಶಂಸಿಸಿದೆ",
    createApplause: "ಪ್ರಶಂಸೆ ರಚಿಸಿ",
    createApplauseDesc: "ಸ್ವತಃ ಅಥವಾ ಇತರರಿಗಾಗಿ ಪ್ರಶಂಸೆ ರಚಿಸಿ. ಉತ್ತಮವಾಗಿ ಬರೆಯಲು ಮತ್ತು ಉತ್ತರಿಸಲು AI ಸಹಾಯ ಪಡೆಯಿರಿ!",
    applauseDate: "ಪ್ರಶಂಸೆ ದಿನಾಂಕ",
    description: "ವಿವರಣೆ",
    applauseTrend: "ಪ್ರಶಂಸೆ ಪ್ರವೃತ್ತಿ",
    monthlyAnalytics: "ಮಾಸಿಕ ವಿಶ್ಲೇಷಣೆ",
    applausePercent: "ನನ್ನ ಸ್ವಯಂ ಪ್ರಶಂಸೆ %",
    all: "ಎಲ್ಲಾ",
    today: "ಇಂದು",
    yesterday: "ನಿನ್ನೆ",
    tomorrow: "ನಾಳೆ",
    thisweek: "ಈ ವಾರ",
    lastweek: "ಕಳೆದ ವಾರ",
    nextweek: "ಮುಂದಿನ ವಾರ",
    thismonth: "ಈ ತಿಂಗಳು",
    lastmonth: "ಕಳೆದ ತಿಂಗಳು",
    nextmonth: "ಮುಂದಿನ ತಿಂಗಳು",       
  },

  ml: {
    pendingTasks: "ബാക്കി ജോലികൾ",
    taskCompletionRatio: "ജോലി പൂർത്തീകരണ അനുപാതം",
    rcaEntries: "ഈ മാസത്തെ RCA എൻട്രികൾ",
    sakshamRanking: "സക്ഷം MSME റാങ്കിംഗ്",

    todo1Title: "അസംസ്കൃത വസ്തുക്കൾക്കായി വിതരണക്കാരനെ ഫോളോ-അപ്പ് ചെയ്യുക",
    todo1Desc: "3 ദിവസമായി ബാക്കി | മുൻഗണന: ഉയർന്നത്",
    todo2Title: "GST ഫയലിംഗ് തയ്യാറെടുപ്പ്",
    todo2Desc: "2 ദിവസത്തിനകം അവസാന തീയതി | ധനകാര്യം & അനുസരണം",
    todo3Title: "മെഷീൻ തകരാർ RCA അപ്ഡേറ്റ്",
    todo3Desc: "ഉൽപ്പാദന നില നിരീക്ഷണം",

    operations: "ഓപ്പറേഷൻസ്",
    finance: "ധനകാര്യം",
    production: "ഉൽപ്പാദനം",

    reminderEnabled: "റിമൈൻഡർ സജീവമാക്കി",
    whatsappAlert: "വാട്സ്ആപ്പ് അലർട്ട്",
    rcaLinked: "RCA ലിങ്ക് ചെയ്തു",
    aiReminder: "AI റിമൈൻഡർ",
    emailNotification: "ഇമെയിൽ അറിയിപ്പ്",
    correctiveActionPending: "തിരുത്തൽ നടപടി ബാക്കി",

    list: "പട്ടിക",
    create: "സൃഷ്ടിക്കുക",
    aiInsights: "AI ഉൾക്കാഴ്ചകൾ",
    reports: "റിപ്പോർട്ടുകൾ",
    rewards: "പ്രതിഫലങ്ങൾ",

    mon: "തി",
    tue: "ചൊ",
    wed: "ബു",
    thu: "വ്യാ",
    fri: "വെ",
    sat: "ശ",

    taskCompletionPercent: "ജോലി പൂർത്തീകരണം %",

    dailyProductivityAI: "MSME ഉടമകൾക്കായുള്ള ദൈനംദിന ഉൽപ്പാദനക്ഷമത AI",

    heroDescription:
        "AI സഹായത്തോടെ ഉൽപ്പാദനക്ഷമത, പ്രവർത്തന ശാസ്ത്രീയം, റിമൈൻഡറുകൾ, RCA ട്രാക്കിംഗ്, AI സിഗ്നലുകൾ, വോയ്സ് വർക്ക്‌ഫ്ലോകൾ, MSME ട്രാൻസ്ഫോർമേഷൻ ഇന്റലിജൻസ്।",

    aiStack: "AI സ്റ്റാക്ക്",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "വോയ്സ് AI",

    todoList: "ചെയ്യേണ്ട ജോലികളുടെ പട്ടിക",
    todoListDesc: "AI സഹായത്തോടെ പ്രവർത്തന വർക്ക്‌ഫ്ലോ ട്രാക്കിംഗ്",

    addTask: "ജോലി ചേർക്കുക",

    ttsEnabled: "TTS സജീവമാക്കി",

    createTodo: "പുതിയ ജോലി സൃഷ്ടിക്കുക",
    createTodoDesc:
        "വോയ്സ് പിന്തുണയുള്ള AI സഹായത്തോടെ ജോലി സൃഷ്ടിക്കൽ വർക്ക്‌ഫ്ലോ",

    taskTitle: "ജോലിയുടെ ശീർഷകം",
    enterTaskTitle: "ജോലിയുടെ ശീർഷകം നൽകുക",

    priority: "മുൻഗണന",
    high: "ഉയർന്നത്",
    medium: "ഇടത്തരം",
    low: "കുറഞ്ഞത്",

    taskDetails: "ജോലി വിശദാംശങ്ങൾ",

    taskDetailsPlaceholder:
        "പ്രാദേശിക ഭാഷയിൽ വോയ്സ് അല്ലെങ്കിൽ ടെക്സ്റ്റ് അടിസ്ഥാനത്തിലുള്ള ജോലി ഇൻപുട്ട്",

    startVoiceInput: "വോയ്സ് ഇൻപുട്ട് ആരംഭിക്കുക",
    refineWithAI: "AI ഉപയോഗിച്ച് മെച്ചപ്പെടുത്തുക",

    voiceSupportText:
        "പ്രാദേശിക ഭാഷകളിൽ ഹാൻഡ്സ്-ഫ്രീ ജോലി സൃഷ്ടിക്കാനായി Speech-to-Text (STT) പിന്തുണ।",

    productivityTrend: "ഉൽപ്പാദനക്ഷമത പ്രവണതി",
    weeklyAnalytics: "ആഴ്ച്ചയിലെ ജോലി പൂർത്തീകരണ വിശകലനം",

    aiInsightsSignals: "AI ഉൾക്കാഴ്ചകൾ / AI സിഗ്നലുകൾ",

    aiInsightsDesc:
        "സന്ദർഭപരമായ പ്രവർത്തന ഇന്റലിജൻസ്, Cognitive AI, സ്വയംപ്രവർത്തക ഏജന്റുകൾ, പ്രവർത്തന ഡയഗ്നോസ്റ്റിക്സ്, MSME അപകടസൂചനകൾ।",

    applause: "പ്രശംസ",
    applauseSub: "അർത്ഥപൂർണ്ണമായ പ്രശംസ നൽകുക, സ്വീകരിക്കുക, പിന്തുടരുക",
    gratitude: "കൃതജ്ഞത",
    applauseList: "പ്രശംസ പട്ടിക",
    applauseListDesc: "പ്രശംസ, പ്രതികരണം, അർത്ഥപൂർണ്ണമായ അംഗീകാരം എന്നിവ ഒരിടത്ത് ശേഖരിച്ചിരിക്കുന്നു",
    addApplause: "വീണ്ടും പ്രശംസിക്കുക",
    listenList: "ശ്രവണ പട്ടിക",
    myself: "സ്വയം പ്രശംസ",
    tome: "എനിക്ക് പ്രശംസ ലഭിച്ചു",
    fromme: "ഞാൻ പ്രശംസിച്ചു",
    createApplause: "പ്രശംസ സൃഷ്ടിക്കുക",
    createApplauseDesc: "സ്വന്തത്തിനോ മറ്റുള്ളവർക്കോ വേണ്ടി പ്രശംസ സൃഷ്ടിക്കുക. മികച്ച രീതിയിൽ എഴുതാനും മറുപടി നൽകാനും AI സഹായം ഉപയോഗിക്കുക!",
    applauseDate: "പ്രശംസ തീയതി",
    description: "വിവരണം",
    applauseTrend: "പ്രശംസ പ്രവണതി",
    monthlyAnalytics: "മാസാന്ത്യ വിശകലനം",
    applausePercent: "എന്റെ സ്വയം പ്രശംസ %",
    all: "എല്ലാം",
    today: "ഇന്ന്",
    yesterday: "ഇന്നലെ",
    tomorrow: "നാളെ",
    thisweek: "ഈ ആഴ്ച",
    lastweek: "കഴിഞ്ഞ ആഴ്ച",
    nextweek: "അടുത്ത ആഴ്ച",
    thismonth: "ഈ മാസം",
    lastmonth: "കഴിഞ്ഞ മാസം",
    nextmonth: "അടുത്ത മാസം",
  },

  pa: {
    pendingTasks: "ਬਾਕੀ ਕੰਮ",
    taskCompletionRatio: "ਕੰਮ ਪੂਰਾ ਹੋਣ ਦਾ ਅਨੁਪਾਤ",
    rcaEntries: "ਇਸ ਮਹੀਨੇ ਦੀਆਂ RCA ਐਂਟਰੀਆਂ",
    sakshamRanking: "ਸਕਸ਼ਮ MSME ਰੈਂਕਿੰਗ",

    todo1Title: "ਕੱਚੇ ਮਾਲ ਲਈ ਵੇਂਡਰ ਨਾਲ ਫਾਲੋ-ਅੱਪ ਕਰੋ",
    todo1Desc: "3 ਦਿਨਾਂ ਤੋਂ ਬਾਕੀ | ਤਰਜੀਹ: ਉੱਚ",
    todo2Title: "GST ਫਾਈਲਿੰਗ ਤਿਆਰੀ",
    todo2Desc: "2 ਦਿਨਾਂ ਵਿੱਚ ਮਿਆਦ | ਵਿੱਤ ਅਤੇ ਅਨੁਕੂਲਤਾ",
    todo3Title: "ਮਸ਼ੀਨ ਖਰਾਬੀ RCA ਅਪਡੇਟ",
    todo3Desc: "ਉਤਪਾਦਨ ਫਲੋਰ ਨਿਰੀਖਣ",

    operations: "ਓਪਰੇਸ਼ਨ",
    finance: "ਵਿੱਤ",
    production: "ਉਤਪਾਦਨ",

    reminderEnabled: "ਰੀਮਾਈਂਡਰ ਚਾਲੂ",
    whatsappAlert: "ਵਟਸਐਪ ਅਲਰਟ",
    rcaLinked: "RCA ਲਿੰਕ ਕੀਤਾ ਗਿਆ",
    aiReminder: "AI ਰੀਮਾਈਂਡਰ",
    emailNotification: "ਈਮੇਲ ਸੂਚਨਾ",
    correctiveActionPending: "ਸੁਧਾਰਾਤਮਕ ਕਾਰਵਾਈ ਬਾਕੀ",

    list: "ਸੂਚੀ",
    create: "ਬਣਾਓ",
    aiInsights: "AI ਅੰਦਰੂਨੀ ਜਾਣਕਾਰੀਆਂ",
    reports: "ਰਿਪੋਰਟਾਂ",
    rewards: "ਇਨਾਮ",

    mon: "ਸੋਮ",
    tue: "ਮੰਗਲ",
    wed: "ਬੁੱਧ",
    thu: "ਵੀਰ",
    fri: "ਸ਼ੁੱਕਰ",
    sat: "ਸ਼ਨੀ",

    taskCompletionPercent: "ਕੰਮ ਪੂਰਾ %",

    dailyProductivityAI: "MSME ਮਾਲਕਾਂ ਲਈ ਰੋਜ਼ਾਨਾ ਉਤਪਾਦਕਤਾ AI",

    heroDescription:
        "AI ਸਹਾਇਤਾ ਵਾਲੀ ਉਤਪਾਦਕਤਾ, ਓਪਰੇਸ਼ਨਲ ਅਨੁਸ਼ਾਸਨ, ਰੀਮਾਈਂਡਰ, RCA ਟ੍ਰੈਕਿੰਗ, AI ਸੰਕੇਤ, ਵੋਇਸ ਵਰਕਫਲੋ ਅਤੇ MSME ਰੂਪਾਂਤਰਨ ਬੁੱਧਿਮਤਾ।",

    aiStack: "AI ਸਟੈਕ",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ਵੋਇਸ AI",

    todoList: "ਕਰਨ ਵਾਲੇ ਕੰਮਾਂ ਦੀ ਸੂਚੀ",
    todoListDesc: "AI ਸਹਾਇਤਾ ਵਾਲੀ ਓਪਰੇਸ਼ਨਲ ਵਰਕਫਲੋ ਟ੍ਰੈਕਿੰਗ",

    addTask: "ਕੰਮ ਸ਼ਾਮਲ ਕਰੋ",

    ttsEnabled: "TTS ਚਾਲੂ",

    createTodo: "ਨਵਾਂ ਕੰਮ ਬਣਾਓ",
    createTodoDesc:
        "ਵੋਇਸ ਸਮਰਥਿਤ AI ਸਹਾਇਤਾ ਵਾਲਾ ਕੰਮ ਬਣਾਉਣ ਵਰਕਫਲੋ",

    taskTitle: "ਕੰਮ ਦਾ ਸਿਰਲੇਖ",
    enterTaskTitle: "ਕੰਮ ਦਾ ਸਿਰਲੇਖ ਦਰਜ ਕਰੋ",

    priority: "ਤਰਜੀਹ",
    high: "ਉੱਚ",
    medium: "ਦਰਮਿਆਨਾ",
    low: "ਘੱਟ",

    taskDetails: "ਕੰਮ ਦੇ ਵੇਰਵੇ",

    taskDetailsPlaceholder:
        "ਸਥਾਨਕ ਭਾਸ਼ਾ ਵਿੱਚ ਵੋਇਸ ਜਾਂ ਟੈਕਸਟ ਅਧਾਰਿਤ ਕੰਮ ਇਨਪੁੱਟ",

    startVoiceInput: "ਵੋਇਸ ਇਨਪੁੱਟ ਸ਼ੁਰੂ ਕਰੋ",
    refineWithAI: "AI ਨਾਲ ਸੁਧਾਰੋ",

    voiceSupportText:
        "ਸਥਾਨਕ ਭਾਸ਼ਾਵਾਂ ਵਿੱਚ ਹੱਥ-ਮੁਕਤ ਕੰਮ ਬਣਾਉਣ ਲਈ Speech-to-Text (STT) ਸਮਰਥਨ।",

    productivityTrend: "ਉਤਪਾਦਕਤਾ ਰੁਝਾਨ",
    weeklyAnalytics: "ਹਫਤਾਵਾਰੀ ਕੰਮ ਪੂਰਾ ਵਿਸ਼ਲੇਸ਼ਣ",

    aiInsightsSignals: "AI ਇਨਸਾਈਟਸ / AI ਸੰਕੇਤ",

    aiInsightsDesc:
        "ਸੰਦਰਭਾਤਮਕ ਓਪਰੇਸ਼ਨਲ ਇੰਟੈਲੀਜੈਂਸ, Cognitive AI, ਸਵੈਚਾਲਿਤ ਏਜੰਟ, ਓਪਰੇਸ਼ਨਲ ਡਾਇਗਨੋਸਟਿਕਸ ਅਤੇ MSME ਜੋਖਿਮ ਸੰਕੇਤ।",

    applause: "ਸ਼ਲਾਘਾ",
    applauseSub: "ਅਰਥਪੂਰਨ ਸ਼ਲਾਘਾ ਦਿਓ, ਪ੍ਰਾਪਤ ਕਰੋ ਅਤੇ ਟ੍ਰੈਕ ਕਰੋ",
    gratitude: "ਕ੍ਰਿਤਜਤਾ",
    applauseList: "ਸ਼ਲਾਘਾ ਸੂਚੀ",
    applauseListDesc: "ਸ਼ਲਾਘਾ, ਫੀਡਬੈਕ ਅਤੇ ਅਰਥਪੂਰਨ ਮਾਨਤਾ ਇੱਕ ਹੀ ਥਾਂ ਤੇ ਸੰਭਾਲੀ ਗਈ ਹੈ",
    addApplause: "ਫਿਰ ਤੋਂ ਸ਼ਲਾਘਾ ਕਰੋ",
    listenList: "ਸੁਣਨ ਦੀ ਸੂਚੀ",
    myself: "ਸਵੈ-ਸ਼ਲਾਘਾ",
    tome: "ਮੈਨੂੰ ਸ਼ਲਾਘਾ ਮਿਲੀ",
    fromme: "ਮੈਂ ਸ਼ਲਾਘਾ ਕੀਤੀ",
    createApplause: "ਸ਼ਲਾਘਾ ਬਣਾਓ",
    createApplauseDesc: "ਆਪਣੇ ਲਈ ਜਾਂ ਹੋਰਾਂ ਲਈ ਸ਼ਲਾਘਾ ਬਣਾਓ। ਵਧੀਆ ਲਿਖਣ ਅਤੇ ਜਵਾਬ ਦੇਣ ਲਈ AI ਦੀ ਮਦਦ ਲਓ!",
    applauseDate: "ਸ਼ਲਾਘਾ ਦੀ ਤਾਰੀਖ",
    description: "ਵੇਰਵਾ",
    applauseTrend: "ਸ਼ਲਾਘਾ ਰੁਝਾਨ",
    monthlyAnalytics: "ਮਾਸਿਕ ਵਿਸ਼ਲੇਸ਼ਣ",
    applausePercent: "ਮੇਰੀ ਸਵੈ-ਸ਼ਲਾਘਾ %",
    all: "ਸਭ",
    today: "ਅੱਜ",
    yesterday: "ਕੱਲ੍ਹ",
    tomorrow: "ਭਲਕੇ",
    thisweek: "ਇਸ ਹਫ਼ਤੇ",
    lastweek: "ਪਿਛਲੇ ਹਫ਼ਤੇ",
    nextweek: "ਅਗਲੇ ਹਫ਼ਤੇ",
    thismonth: "ਇਸ ਮਹੀਨੇ",
    lastmonth: "ਪਿਛਲੇ ਮਹੀਨੇ",
    nextmonth: "ਅਗਲੇ ਮਹੀਨੇ",       
  },

  as: {
    pendingTasks: "অমীমাংসিত কামসমূহ",
    taskCompletionRatio: "কাম সম্পূৰ্ণ অনুপাত",
    rcaEntries: "এই মাহৰ RCA এণ্ট্ৰিসমূহ",
    sakshamRanking: "সক্ষম MSME ৰেংকিং",

    todo1Title: "কেঁচা সামগ্ৰীৰ বাবে বিক্ৰেতাৰ সৈতে অনুসৰণ কৰক",
    todo1Desc: "৩ দিন ধৰি বাকী | অগ্ৰাধিকাৰ: উচ্চ",
    todo2Title: "GST ফাইলিং প্ৰস্তুতি",
    todo2Desc: "২ দিনৰ ভিতৰত শেষ তাৰিখ | বিত্ত আৰু অনুগত্য",
    todo3Title: "মেচিন বিকল RCA আপডেট",
    todo3Desc: "উৎপাদন ফ্ল’ৰ পৰ্যবেক্ষণ",

    operations: "অপাৰেশ্যন",
    finance: "বিত্ত",
    production: "উৎপাদন",

    reminderEnabled: "স্মাৰক সক্ৰিয়",
    whatsappAlert: "হোৱাটছএপ সতর্কতা",
    rcaLinked: "RCA সংযুক্ত",
    aiReminder: "AI স্মাৰক",
    emailNotification: "ইমেইল জাননী",
    correctiveActionPending: "সংশোধনী ব্যৱস্থা বাকী",

    list: "তালিকা",
    create: "সৃষ্টি কৰক",
    aiInsights: "AI অন্তৰ্দৃষ্টি",
    reports: "ৰিপৰ্টসমূহ",
    rewards: "পুৰস্কাৰ",

    mon: "সোম",
    tue: "মঙ্গল",
    wed: "বুধ",
    thu: "বৃহস্পতি",
    fri: "শুক্ৰ",
    sat: "শনি",

    taskCompletionPercent: "কাম সম্পূৰ্ণ %",

    dailyProductivityAI: "MSME মালিকসকলৰ বাবে দৈনিক উৎপাদনশীলতা AI",

    heroDescription:
        "AI সহায়িত উৎপাদনশীলতা, অপাৰেশ্যন শৃংখলা, স্মাৰক, RCA ট্ৰেকিং, AI সংকেত, ভয়েচ ৱৰ্কফ্লো আৰু MSME ৰূপান্তৰ বুদ্ধিমত্তা।",

    aiStack: "AI ষ্টেক",
    aiStackValue: "LLM + RAG + Cognitive Agents",

    voiceAI: "ভয়েচ AI",

    todoList: "কৰণীয় কামৰ তালিকা",
    todoListDesc: "AI সহায়িত অপাৰেশ্যনেল ৱৰ্কফ্লো ট্ৰেকিং",

    addTask: "কাম যোগ কৰক",

    ttsEnabled: "TTS সক্ৰিয়",

    createTodo: "নতুন কাম সৃষ্টি কৰক",
    createTodoDesc:
        "ভয়েচ-সক্ষম AI সহায়িত কাম সৃষ্টি ৱৰ্কফ্লো",

    taskTitle: "কামৰ শিৰোনাম",
    enterTaskTitle: "কামৰ শিৰোনাম লিখক",

    priority: "অগ্ৰাধিকাৰ",
    high: "উচ্চ",
    medium: "মধ্যম",
    low: "নিম্ন",

    taskDetails: "কামৰ বিৱৰণ",

    taskDetailsPlaceholder:
        "স্থানীয় ভাষাত ভয়েচ বা টেক্সট-ভিত্তিক কাম ইনপুট",

    startVoiceInput: "ভয়েচ ইনপুট আৰম্ভ কৰক",
    refineWithAI: "AI সহ উন্নত কৰক",

    voiceSupportText:
        "স্থানীয় ভাষাসমূহত হেণ্ডছ-ফ্ৰী কাম সৃষ্টিৰ বাবে Speech-to-Text (STT) সমৰ্থন।",

    productivityTrend: "উৎপাদনশীলতাৰ ধাৰা",
    weeklyAnalytics: "সাপ্তাহিক কাম সম্পূৰ্ণ বিশ্লেষণ",

    aiInsightsSignals: "AI অন্তৰ্দৃষ্টি / AI সংকেত",

    aiInsightsDesc:
        "প্ৰাসংগিক অপাৰেশ্যনেল বুদ্ধিমত্তা, Cognitive AI, স্বয়ংক্ৰিয় এজেণ্ট, অপাৰেশ্যনেল ডায়াগনষ্টিক্স আৰু MSME ঝুঁকি সংকেত।",

    applause: "প্ৰশংসা",
    applauseSub: "অৰ্থপূৰ্ণ প্ৰশংসা দিয়ক, গ্ৰহণ কৰক আৰু অনুসৰণ কৰক",
    gratitude: "কৃতজ্ঞতা",
    applauseList: "প্ৰশংসাৰ তালিকা",
    applauseListDesc: "প্ৰশংসা, মতামত আৰু অৰ্থপূৰ্ণ স্বীকৃতি একে ঠাইত সংৰক্ষণ কৰা হৈছে",
    addApplause: "আকৌ প্ৰশংসা কৰক",
    listenList: "শুনা তালিকা",
    myself: "নিজকে প্ৰশংসা",
    tome: "মই প্ৰশংসা পালোঁ",
    fromme: "মই প্ৰশংসা কৰিলোঁ",
    createApplause: "প্ৰশংসা সৃষ্টি কৰক",
    createApplauseDesc: "নিজৰ বা আনৰ বাবে প্ৰশংসা সৃষ্টি কৰক। ভালকৈ লিখিবলৈ আৰু উত্তৰ দিবলৈ AI ৰ সহায় লওক!",
    applauseDate: "প্ৰশংসাৰ তাৰিখ",
    description: "বিৱৰণ",
    applauseTrend: "প্ৰশংসাৰ ধাৰা",
    monthlyAnalytics: "মাহেকীয়া বিশ্লেষণ",
    applausePercent: "মোৰ নিজা প্ৰশংসা %",
    all: "সকলো",
    today: "আজি",
    yesterday: "কালি",
    tomorrow: "কাইলৈ",
    thisweek: "এই সপ্তাহ",
    lastweek: "যোৱা সপ্তাহ",
    nextweek: "আগন্তুক সপ্তাহ",
    thismonth: "এই মাহ",
    lastmonth: "যোৱা মাহ",
    nextmonth: "আগন্তুক মাহ",        
  },
};

export default msmeOwnerPATranslations;